
import { defineComponent } from 'vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import Message from 'primevue/message'

export default defineComponent({
    name: 'lovs-management-preview-dialog',
    components: { Column, DataTable, Dialog, Message },
    emits: ['close', 'pageChanged'],
    props: {
        visible: { type: Boolean },
        dataForPreview: { type: Object, required: true },
        pagination: { type: Object }
    },
    data() {
        return {
            columns: [] as any[],
            rows: [] as any[],
            lazyParams: {} as any,
            sorted: 'ASC'
        }
    },
    watch: {
        dataForPreview() {
            this.loadData()
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            if (this.dataForPreview.metaData?.fields) {
                this.formatColumns()
            }
            this.loadPagination()
            this.rows = this.dataForPreview.root
        },
        formatColumns() {
            this.columns = []
            for (let i = 0; i < this.dataForPreview.metaData.fields.length; i++) {
                this.columns.push({ field: this.dataForPreview.metaData.fields[i].name, header: this.dataForPreview.metaData.fields[i].name })
            }
        },
        loadPagination() {
            this.lazyParams = this.pagination as any
        },
        onPage(event: any) {
            this.lazyParams = { paginationStart: event.first, paginationLimit: event.rows, paginationEnd: event.first + event.rows, size: this.lazyParams.size }
            this.$emit('pageChanged', this.lazyParams)
        },
        onSort() {
            if (this.sorted === 'DESC') {
                this.rows = this.rows.sort((a: any, b: any) => (a.sortField > b.sortField ? 1 : -1))
                this.sorted = 'ASC'
            } else {
                this.rows = this.rows.sort((a: any, b: any) => (a.sortField < b.sortField ? 1 : -1))
                this.sorted = 'DESC'
            }
        }
    }
})
